<template>
  <!-- 选择课程类型 组件 -->
  <el-select v-model="selected" placeholder="请选择课程类型" @change="changeCourseType" clearable>
    <el-option v-for="item in courseTypeList" :key="item.id" :label="item.typeName" :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
  export default {
    props: {
      // 是否是编辑
      isEdit: {
        type: Boolean,
        default: false,
      },
      // 回显值
      editSelected: {
        type: Number,
      }
    },
    data() {
      return {
        selected: '',
        courseTypeList: []
      }
    },
    computed: {},
    watch: {
      editSelected(newVal, oldVal) {
        if (!newVal) return
        this.selected = this.editSelected;
      }
    },
    methods: {
      // 获取学科列表
      async getCourseTypeList() {
        let resData = await this.$Api.Course.TypeList();
        this.courseTypeList = resData.data;
        // this.selected = resData.data[0].id;
        if(!this.isEdit) this.$emit('courseType', this.selected);
        
      },
      // 切换学科
      changeCourseType(val) {
        this.$emit('courseType', val);
      },
    },
    mounted() {
      this.getCourseTypeList();
    },
  }
</script>

<style>

</style>